(function () {
  // product accordions: only one open at a time
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    var box = d.closest('.dr-product-info, .dr-product-info__list, .dr-main-product, [class*="main-product"]');
    if (!box) return;
    box.querySelectorAll('details[open]').forEach(function (o) {
      if (o !== d && !o.contains(d) && !d.contains(o) && /accordion/i.test(o.className + ' ' + (o.parentElement ? o.parentElement.className : ''))) o.open = false;
    });
  }, true);

  // main menu: clicking outside the panel closes it
  document.addEventListener('click', function (e) {
    var dlg = document.getElementById('menu_mobile');
    if (!dlg || !dlg.open) return;
    if (e.target === dlg || e.target.closest('.dr-menu__imgs')) {
      var c = dlg.querySelector('.dr-menu__close') || dlg.querySelector('.dr-dialog-btn__close');
      if (c) c.click();
    }
  });
})();
